
import { mixins } from 'vue-class-component';
import CampaignWidgetMixin from '@/mixins/campaignWidget';
import { CountdownType } from '@/store';

export default class MCountdown extends mixins(CampaignWidgetMixin) {
  get countdown() {
    return this.getters.countdown;
  }
  get activeCountdown() {
    return [CountdownType.TO_START, CountdownType.TO_END].indexOf(this.getters.countdownType) >= 0;
  }
  get countdownTypeText() {
    let retval;
    const countdownType = this.getters.countdownType;

    if (countdownType === CountdownType.TO_START) {
      retval = 'Campaign starts';
    } else if (countdownType === CountdownType.TO_END) {
      retval = 'Campaign ends';
    } else if (countdownType === CountdownType.EXPIRED) {
      retval = 'Campaign ended';
    } else if (countdownType === CountdownType.LOADING) {
      retval = 'Loading...';
    } else {
      retval = '';
    }

    return retval;
  }
}
